import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import hacko from '../assets/images/hacko.jpg';
import photoshop from '../assets/images/photoshop.png';
import hacker3 from '../assets/images/hacker2.webp';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';

class Cyber extends Component{
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header className="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${hacker3})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span className="alt-col" style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"The quieter you become, the more you are able to hear."</p>
                <p>
                &mdash; Kali Linux.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div style={{backgroundImage: `url(${hacko})`, backgroundClip:'border-box', backgroundPosition:'center', backgroundSize:'cover'}}></div>

            <div>
            <h3 className="path">ethical hacking</h3>
            <img src={photoshop} alt="Full-stack JavaScript training in abuja" />
            <p> 
              Ethical hacking is performed to help identify threat on a computer or network. Learn how to perform penetration tests by scanning for open ports
              and other vulnerabilites.
            </p>
            <p> 
            This course takes you through a step-by-step guide to performing your first exploit.
            </p>

            <h3>courses</h3>
            <p>
                Kali Linux.
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}

export default Cyber;